// extracted by mini-css-extract-plugin
export default {"footerContainer":"styles_footerContainer__gzdTH","footerButton":"styles_footerButton__EP4UB","separator":"styles_separator__gM2io"};